import {wrap} from 'svelte-spa-router/wrap';

import Simple from './simple/Simple.svelte';
import Calculate from './calculate/Calculate.svelte';
import NotFound from './NotFound.svelte';

export default {
    '/': wrap({
        component: Calculate,
        props: {
            API_URL: process.env.APP_API_URL,
            API_URL_PUBLIC: process.env.APP_API_URL_PUBLIC,
            privateVersion: process.env.APP_privateVersion === 'true'
        }
    }),
    '/calculate': wrap({
        component: Calculate,
        props: {
            API_URL: process.env.APP_API_URL,
            API_URL_PUBLIC: process.env.APP_API_URL_PUBLIC,
            privateVersion: process.env.APP_privateVersion === 'true'
        }
    }),
    '/old': wrap({
        component: Simple,
        props: {
            API_URL: process.env.APP_API_URL,
            API_URL_PUBLIC: process.env.APP_API_URL_PUBLIC,
            privateVersion: process.env.APP_privateVersion === 'true'
        }
    }),
    '*': NotFound // ici composant direct, pas besoin de wrap
};